// 发布作品 抖音
const dyRoutes = Array.from({ length: 24 }, (_, i) => ({
  path: `publishWorks/dy/index${i + 1}`,
  name: `publishWorks/dy/Index${i + 1}`,
  component: () => import(`@/views/entertainment/publishWorks/dy/index${i + 1}.vue`)
}))

const branch1PublishDyRoutes = Array.from({ length: 24 }, (_, i) => ({
  path: `publishWorks/dy/branch1/index${i + 1}`,
  name: `publishWorks/dy/branch1/Index${i + 1}`,
  component: () => import(`@/views/entertainment/publishWorks/dy/branch1/index${i + 1}.vue`)
}))

const branch2PublishDyRoutes = Array.from({ length: 24 }, (_, i) => ({
  path: `publishWorks/dy/branch2/index${i + 1}`,
  name: `publishWorks/dy/branch2/Index${i + 1}`,
  component: () => import(`@/views/entertainment/publishWorks/dy/branch2/index${i + 1}.vue`)
}))

const branch3PublishDyRoutes = Array.from({ length: 24 }, (_, i) => ({
  path: `publishWorks/dy/branch3/index${i + 1}`,
  name: `publishWorks/dy/branch3/Index${i + 1}`,
  component: () => import(`@/views/entertainment/publishWorks/dy/branch3/index${i + 1}.vue`)
}))


// 发布作品 美篇
const mpRoutes = Array.from({ length: 24}, (_, i) => ({
  path: `publishWorks/mp/index${i + 1}`,
  name: `publishWorks/mp/Index${i + 1}`,
  component: () => import(`@/views/entertainment/publishWorks/mp/index${i + 1}.vue`)
}))

// 发布作品 小红书
const xhsRoutes = Array.from({ length: 24}, (_, i) => ({
  path: `publishWorks/xhs/index${i + 1}`,
  name: `publishWorks/xhs/Index${i + 1}`,
  component: () => import(`@/views/entertainment/publishWorks/xhs/index${i + 1}.vue`)
}))

import publishWorksIndex from '@/views/entertainment/publishWorks/index'



export default {
  path: '/entertainment',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
      {
        path: 'publishWorks/index',
        name: 'publishWorksIndex',
        component: publishWorksIndex
      },

    ...dyRoutes,
    ...branch1PublishDyRoutes,
    ...branch2PublishDyRoutes,
    ...branch3PublishDyRoutes,
    ...mpRoutes,
    ...xhsRoutes,

  ],
};
